<div class="my-3">
    <form [formGroup]="filtersForm">
        <div style="display: flex; justify-content: flex-end">
            <p><mat-slide-toggle formControlName="onlySecretsAboutToExpire">About to expire</mat-slide-toggle></p>
        </div>
    </form>

    <div class="my-3">
        <mat-progress-spinner
            *ngIf="isLoading()"
            mode="indeterminate"
            diameter="30"
            color="primary"
            style="margin: 20px auto; display: block"
        >
        </mat-progress-spinner>
    </div>

    <div class="my-3">
        @if (connections$ | async; as connections) {
            <table mat-table [dataSource]="connections" class="mat-elevation-z8">
                <ng-container matColumnDef="connectionAlias">
                    <th mat-header-cell *matHeaderCellDef>Connection</th>
                    <td mat-cell *matCellDef="let element" [title]="element.connection.stateMessage ?? ''">
                        @if (element.connection.state === 'Failed') {
                            <mat-icon
                                class="connection-state-icon connection-state-icon-failed"
                                aria-label="Connection failed"
                                title="Connection failed"
                            >
                                error
                            </mat-icon>
                        } @else if (element.connection.state === 'Pending') {
                            <mat-icon
                                class="connection-state-icon connection-state-icon-pending"
                                aria-label="Connection pending"
                                title="Connection pending"
                            >
                                hourglass_top
                            </mat-icon>
                        }
                        {{ getConnectionDisplayName(element) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="businessDomainName">
                    <th mat-header-cell *matHeaderCellDef>Business Domain</th>
                    <td mat-cell *matCellDef="let element">{{ element.businessDomain.name }}</td>
                </ng-container>

                <ng-container matColumnDef="connectionHost">
                    <th mat-header-cell *matHeaderCellDef>Host</th>
                    <td mat-cell *matCellDef="let element">{{ element.connection.host }}</td>
                </ng-container>

                <ng-container matColumnDef="connectionUsername">
                    <th mat-header-cell *matHeaderCellDef>Username</th>
                    <td mat-cell *matCellDef="let element">{{ element.connection.username }}</td>
                </ng-container>

                <ng-container matColumnDef="secretDisplayName">
                    <th mat-header-cell *matHeaderCellDef>Secret</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.connection.secret) {
                            <a
                                [href]="
                                    'https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Credentials/appId/' +
                                    element.connection.secret.clientId +
                                    '/isMSAApp~/false'
                                "
                                target="_blank"
                            >
                                {{ element.connection.secret.displayName }}
                            </a>
                        } @else {
                            <p style="text-align: center">-</p>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="secretExpiresAt">
                    <th mat-header-cell *matHeaderCellDef>Expires (UTC)</th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        [style.background-color]="getBackgroundColorForExpiresAtCell(element)"
                        [style.font-weight]="getFontWeightForExpiresAtCell(element)"
                    >
                        <p style="text-align: center">{{ getFormattedExpirationDate(element) }}</p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cellF *matCellDef="let element">
                        @if (element.connection.state === 'Failed' && element.connection.type === 'DataLake') {
                            <button
                                mat-icon-button
                                (click)="retryFailedConnection(element)"
                                aria-label="Retry connection"
                            >
                                <mat-icon>refresh</mat-icon>
                            </button>
                        }
                        @if (element.connection.secret?.state || element.connection.requestAccessURL !== '') {
                            <button mat-icon-button [matMenuTriggerFor]="actionsMenu" aria-label="Actions">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionsMenu="matMenu">
                                <!-- Refresh secret -->
                                @if (element.connection.secret?.state) {
                                    <button
                                        mat-menu-item
                                        (click)="onRefreshSecret(element)"
                                        [disabled]="element.connection.secret?.state === 'Processing'"
                                    >
                                        <mat-icon>refresh</mat-icon>
                                        <span>
                                            {{
                                                element.connection.secret?.state === 'Active'
                                                    ? 'Refresh secret'
                                                    : 'Refreshing secret'
                                            }}
                                        </span>
                                    </button>
                                }

                                <!-- Request access -->

                                @if (element.connection.requestAccessURL) {
                                    <a
                                        mat-menu-item
                                        [href]="element.connection.requestAccessURL"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        <mat-icon>lock_open</mat-icon>
                                        <span>Request access</span>
                                    </a>
                                }
                            </mat-menu>
                        }
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        }
    </div>
</div>
